import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Tooltip, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useField } from 'formik';
import classNames from 'classnames';

import { CustomSVG, ValidatedSwitch } from 'components';

interface IProps {
  network: string;
}

const useStyles = makeStyles(theme => ({
  icon: {
    marginRight: theme.spacing(1),
    color: theme.custom.palette.grey2,
  },
  help: {
    color: theme.custom.palette.grey3,
  },
  inactive: {
    color: theme.custom.palette.grey2,
  },
  active: {
    color: theme.custom.palette.black1,
  },
}));

const EngagePost: FC<IProps> = ({ network }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [field] = useField({ name: 'is_engageable' });
  const { value } = field;

  return (
    <Grid container alignItems="center" justify="space-between">
      <Grid item container xs alignItems="center">
        <CustomSVG
          name="pin"
          className={classNames(classes.icon, {
            [classes.active]: value,
            [classes.inactive]: !value,
          })}
        />
        <Tooltip title={t('posting:engageTooltip')} placement="top">
          <Typography className={value ? classes.active : classes.inactive}>
            {t('posting:engage')}
          </Typography>
        </Tooltip>
      </Grid>
      <Grid item container xs alignItems="center" justify="flex-end">
        <ValidatedSwitch
          name="is_engageable"
          color="primary"
          label={
            <Typography className={value ? classes.active : classes.inactive}>
              {t(`admin:${network}`)}
            </Typography>
          }
        />
      </Grid>
    </Grid>
  );
};

export default EngagePost;
